import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import AuthLayout, { Field, inputCls } from "@/pages/AuthLayout";

const DEMO = [
  { label: "Sovereign Admin", email: "ankit@tracknext.com", password: "N360Sovereign!2026" },
  { label: "Platinum Minister", email: "elena.rostova@n360.demo", password: "Demo123!" },
  { label: "Strategic Steward", email: "marcus.vance@n360.demo", password: "Demo123!" },
  { label: "Field Associate", email: "arthur.hayes@n360.demo", password: "Demo123!" },
];

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e, creds) => {
    if (e) e.preventDefault();
    const em = creds?.email ?? email;
    const pw = creds?.password ?? password;
    setLoading(true);
    try {
      await login(em, pw);
      toast.success("Clearance verified. Welcome back.");
      navigate("/app");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Enter the Network"
      subtitle="Authenticate to access the sovereign intelligence directory."
      footer={<>New principal? <Link to="/signup" className="text-[#F1551D] hover:underline">Request clearance</Link></>}
    >
      <form onSubmit={submit}>
        <Field label="Institutional Email">
          <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="you@institution.org" />
        </Field>
        <Field label="Passphrase">
          <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
        </Field>
        <div className="flex justify-end mb-4">
          <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs text-[#5f7d86] hover:text-[#F1551D]">Forgot passphrase?</Link>
        </div>
        <button data-testid="login-submit-btn" disabled={loading} className="w-full py-2.5 rounded-lg btn-gold font-semibold disabled:opacity-60">
          {loading ? "Verifying…" : "Authenticate"}
        </button>
      </form>

      <div className="mt-6 pt-5 border-t border-[#F1551D]/15">
        <div className="text-[11px] uppercase tracking-wider text-[#8598a0] mb-2.5">Quick demo access</div>
        <div className="grid grid-cols-2 gap-2">
          {DEMO.map((d) => (
            <button key={d.email} data-testid={`demo-login-${d.label.replace(/\s/g, "-")}`} onClick={() => submit(null, d)}
              className="text-xs px-2 py-2 rounded-lg border border-[#F1551D]/20 text-[#2f5561] hover:border-[#F1551D]/50 hover:text-[#B84214] transition-colors">
              {d.label}
            </button>
          ))}
        </div>
      </div>
    </AuthLayout>
  );
}
